import Markdown from "react-markdown";
import t from "../locales/";
import PROFILES from "../data/profiles";
import heartMascot from "../assets/images/heart_mascot.svg";
import arrows from "../assets/images/arrows.svg";
import ShareWidget from "./share_widget";
import { useRef } from "react";

export function ShareSection({ profile, answers }) {
  const { action_habits, action_environment, action_devices } = answers;
  const { devices, habits, environment } = PROFILES[profile];
  const shareBoxRef = useRef(null);

  const isMobile = window.innerWidth < 768;

  const canShare =
    shareBoxRef.value !== null &&
    navigator.canShare &&
    navigator.canShare({
      files: [new File([""], "resultaat.png", { type: "image/png" })],
    });

  return (
    <div className="share">
      <div className="share__header">
        <h1 className="share__title">{t("share.header.title")}</h1>
        <p>
          {t(
            `share.header.subtitle.${isMobile && canShare ? "mobile" : "desktop"}`,
          )}
        </p>
      </div>
      <div className="share__boxes-container" ref={shareBoxRef}>
        <div className="share__banner-container">
          <div className="share__banner">
            <img className="share__image" src={heartMascot} alt="" />
            <h2 className="share__banner-text">{t("share.banner.title")}</h2>
          </div>
          <img className="share__arrows --show-lg" src={arrows} alt="" />
        </div>
        <div className="share__boxes">
          <div className="share__box">
            <div className="share__box-header">
              <Markdown>{t("share.banner.habits")}</Markdown>
            </div>
            <div className="share__box-text">
              <Markdown>{habits.choices[action_habits]}</Markdown>
            </div>
          </div>
          <div className="share__box">
            <div className="share__box-header">
              <Markdown>{t("share.banner.environment")}</Markdown>
            </div>
            <div className="share__box-text">
              <Markdown>{environment.choices[action_environment]}</Markdown>
            </div>
          </div>
          <div className="share__box">
            <div className="share__box-header">
              <Markdown>{t("share.banner.devices")}</Markdown>
            </div>
            <div className="share__box-text">
              <Markdown>{devices.choices[action_devices]}</Markdown>
            </div>
          </div>
        </div>
      </div>
      <div className="widget-container">
        <ShareWidget
          shareBoxRef={shareBoxRef}
          isMobile={isMobile}
          canShare={canShare}
          profile={{
            profile: profile,
            action_habits: action_habits,
            action_environment: action_environment,
            action_devices: action_devices,
          }}
        />
      </div>
    </div>
  );
}
